import React, {useState} from 'react'
import {
    Box,
    Typography,
    IconButton,
    TextField,
    InputAdornment, Rating, ListItemSecondaryAction, ListItemText, ListItem, List,
} from "@mui/material";
import {ArrowUpward, AttachFile, Delete} from "@material-ui/icons";
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import useStyles from "../../../../assets/styles/ProgramRatingStyles";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import {Button} from "@material-ui/core";

const DQProgramRating = ({ data, actions, options }) => {
    const classes = useStyles();
    const { uploadedFiles } = data;
    const { uploadFileAction, deleteFileAction, submitAction } = actions;
    const [dragging, setDragging] = useState(false);
    const handleFileUpload = (event) => {
        event.preventDefault();
        const files =
            event.dataTransfer?.files
                ? Array.from(event.dataTransfer.files) // Drag-and-drop
                : Array.from(event.target.files);
        if (files.length === 0) {
            console.log("Please select at least one file to upload.");
            return;
        }
        // Filter out duplicates
        const uniqueFiles = files.filter(
            (file) => !uploadedFiles.some((uploaded) => uploaded.name === file.name)
        );

        if (uniqueFiles.length === 0) {
            console.log("No new files to upload.");
            return;
        }

        uploadFileAction(uniqueFiles);
        if (event.target) {
            event.target.value = null; // Clear the input
        }
    };

    const handleRemoveFile = (index) => {
        deleteFileAction(index);
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        setDragging(true);
    };

    const handleDragLeave = () => {
        setDragging(false);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        setDragging(false);
        handleFileUpload(event);
    };

    const handleSubmit = () => {
        submitAction();
    };

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "87vh",
                    padding: 4,
                }}
            >
                <Typography
                    variant="h3" sx={{marginBottom: 3}} className={classes.title}
                >
                    Check Your Program’s DQ Alignment
                </Typography>
                {/*<Box sx={{ display: "flex", justifyContent: "center", marginBottom: 2 }}>*/}
                {/*    <Rating*/}
                {/*        value={2}*/}
                {/*        max={3}*/}
                {/*        readOnly*/}
                {/*        icon={<span style={{ color: "#FFD700", fontSize: "80px" }}>★</span>}*/}
                {/*        emptyIcon={<span style={{ color: "#E0E0E0", fontSize: "80px" }}>★</span>}*/}
                {/*    />*/}
                {/*</Box>*/}
                <Typography
                    variant="body1"
                    sx={{
                        fontSize: "1.2rem",
                        textAlign: "center",
                        marginBottom: 4,
                        maxWidth: "630px",
                        color: "#474747",
                    }}
                >
                    Upload your digital literacy education program via Word or PDF and receive a report to check your program’s DQ Alignment. You can add as many files related to your program.
                </Typography>

                {uploadedFiles.length > 0 && (
                    <Box mb={2} style={{ width: "100%",
                        maxWidth: "700px",border:'1px solid #ED6628', borderRadius:'7px', padding:'10px'}}>
                        <Typography variant="h6" style={{color:'#ED6628'}}>Uploaded Files:</Typography>
                        <List>
                            {uploadedFiles.map((file, index) => (
                                <ListItem key={index}>
                                    <ListItemIcon>
                                        <InsertDriveFileIcon style={{ color: '#ED6628' }} />
                                    </ListItemIcon>
                                    <ListItemText primary={file.name} />
                                    <ListItemSecondaryAction>
                                        <IconButton
                                            edge="end"
                                            style={{ color: '#ED6628' }}
                                            onClick={() => handleRemoveFile(index)}
                                        >
                                            <Delete />
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            ))}
                        </List>

                    </Box>
                )}
                <Box className={classes.fileUploadContainer}
                     onDragOver={handleDragOver}
                     onDragLeave={handleDragLeave}
                     onDrop={handleDrop}
                >
                    <TextField
                        fullWidth
                        placeholder="Click here to upload file"
                        sx={{
                            backgroundColor: dragging ? "#fff5f0" : "#fff",
                            borderRadius: '10px',
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                    border: "1px solid #ED6628",
                                },
                                "&:hover fieldset": {
                                    border: "1px solid #ED6628",
                                },
                                "&.Mui-focused fieldset": {
                                    border: "1px solid #ED6628",
                                },
                            },
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <IconButton component="label" onClick={(e) => e.stopPropagation()}>
                                        <AttachFile/>
                                        <input
                                            hidden
                                            type="file"
                                            multiple
                                            accept=".pdf,.doc,.docx"
                                            onChange={handleFileUpload}
                                        />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleSubmit();
                                        }}
                                        sx={{
                                            backgroundColor: "#ED6628",
                                            color: "#fff",
                                            "&:hover": {
                                                backgroundColor: "#ED6628",
                                            },
                                        }}
                                    >
                                        <ArrowUpward />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            readOnly: true,
                        }}
                        onClick={() => document.querySelector('input[type="file"]').click()}/>
                </Box>
                <Box display="flex" gap={2} sx={{mt:5}}>
                    <Button
                        className={classes.actionButton}
                        variant="contained"
                        color="secondary"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleSubmit();
                        }}
                    >
                        SUBMIT
                    </Button>
                </Box>
            </Box>
        </>
    );
}

export default DQProgramRating;